<template>
  <div name="demo-table-sort">
    <hrms-table :columns="columns[nowLang].index"
    			     :data="index" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.sortLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'sort', flgRowCondition)
let mockData = mock.dataSort(flgRowCondition)

export default {
  name: 'demo-table-sort',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableSort.vue?29f23d5c